export default __webpack_public_path__ + "static/media/collaborator.226aabb5.svg";